import { gql } from '@generated/gql';

const getOtsDirectory = gql(`
  query getOtsDirectory {
    fixed_line_ots_directory {
      list {
        listType
        identity {
          id
          name
          processSupport {
            process
            status
          }
          resource {
            name
            type
            value
          }
        }
      }
    }
  }
`);

const otsMatch = gql(`
  query otsMatch($request: BroadbandSwitchingMatchRequestInput!) {
    broadbandOtsMatch(request: $request) {
      id
    }
  }
`);

const getOtsMatch = gql(`
  query getOtsMatch($request: BroadbandSwitchingRequestReferenceInput!) {
    broadbandOtsRetrieveMatch(request: $request) {
      fieldErrors
      implicationCommunications {
        sentBy
        sentMethod
        sentTo
      }
      options {
        broadband {
          action
          identifier
        }
        homePhone {
          action
          identifier
        }
        switchOrderReference
      }
      status
    }
  }
`);

export { getOtsMatch, otsMatch, getOtsDirectory };
